import { intoResult, intoResultAsync } from '@app/packages/Result/Result'

import { ApiError, isPrematureEndError, RequestError, TruncatedResponseError } from './errors'
import { parseHtmlTitle } from './shared'

export async function assertResponseHasNoError(resp: Response, method: string, endpoint: string) {
  if (resp.ok) return
  const text = await resp.text()
  const message = `${method} ${endpoint} call failed`
  const isBan = resp.headers.get('x-crowdsec-remediation') === 'ban'

  if (!text) throw RequestError.create(resp.status, message, 'Missing response text').withHandled(isBan)

  {
    const data = intoResult(() => JSON.parse(text))
    if (!data.error) throw ApiError.create(resp.status, message, data.value).withHandled(isBan)
  }

  html_title: {
    const title = await intoResultAsync(parseHtmlTitle(text))
    if (title.error || !title.value) break html_title
    throw RequestError.create(resp.status, message, title.value).withHandled(isBan)
  }

  throw RequestError.create(resp.status, message, text).withHandled(isBan)
}

/**
 * A body that ended early is a dropped connection, not a bad payload: re-throw it as one so it is
 * handled and exposed like any other network blip. Anything else — a complete body that simply is
 * not the JSON we expected — stays a client error and keeps its Sentry report.
 */
export const parseResponseBody = (text: string, request: string) => {
  try {
    return JSON.parse(text)
  } catch (e) {
    if (!isPrematureEndError(e, text)) throw e
    // Handled explicitly: a genuine fetch rejection is a plain Error, so it picks `handled` up
    // from isNetworkFailError, while every AppError already carries `handled = false`.
    throw new TruncatedResponseError(`${request} response body ended early at ${text.length} bytes`, { cause: e }).withHandled(true)
  }
}
